import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";

// Country data configuration
const COUNTRIES = [
  {
    name: "India",
    flag:
      "https://upload.wikimedia.org/wikipedia/en/thumb/4/41/Flag_of_India.svg/1200px-Flag_of_India.svg.png",
    route: "/immigration/India",
    region: "Asia",
  },
  {
    name: "USA",
    flag:
      "https://cdn.britannica.com/33/4833-050-F6E415FE/Flag-United-States-of-America.jpg",
    route: "/immigration/usa",
    region: "North America",
  },
  {
    name: "Japan",
    flag:
      "https://upload.wikimedia.org/wikipedia/en/thumb/9/9e/Flag_of_Japan.svg/1200px-Flag_of_Japan.svg.png",
    route: "/immigration/japan",
    region: "Asia",
  },
  {
    name: "Australia",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Australia_%28converted%29.svg/800px-Flag_of_Australia_%28converted%29.svg.png",
    route: "/immigration/australia",
    region: "Oceania",
  },
  {
    name: "United Kingdom",
    flag:
      "https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg",
    route: "/immigration/uk",
    region: "Europe",
  },
  {
    name: "Canada",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/800px-Flag_of_Canada_%28Pantone%29.svg.png",
    route: "/immigration/canada",
    region: "North America",
  },
  {
    name: "Germany",
    flag:
      "https://upload.wikimedia.org/wikipedia/en/thumb/b/ba/Flag_of_Germany.svg/1200px-Flag_of_Germany.svg.png",
    route: "/immigration/germany",
    region: "Europe",
  },
  {
    name: "Sweden",
    flag: "https://upload.wikimedia.org/wikipedia/en/4/4c/Flag_of_Sweden.svg",
    route: "/immigration/sweden",
    region: "Europe",
  },
  {
    name: "New Zealand",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Flag_of_New_Zealand.svg/800px-Flag_of_New_Zealand.svg.png",
    route: "/immigration/NewZealand",
    region: "Oceania",
  },
  {
    name: "Netherlands",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Flag_of_the_Netherlands.svg/800px-Flag_of_the_Netherlands.svg.png",
    route: "/immigration/Netherlands",
    region: "Europe",
  },
  {
    name: "Switzerland",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Flag_of_Switzerland.svg/800px-Flag_of_Switzerland.svg.png",
    route: "/immigration/Switzerland",
    region: "Europe",
  },
  {
    name: "South Africa",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Flag_of_South_Africa.svg/250px-Flag_of_South_Africa.svg.png",
    route: "/immigration/south-africa",
    region: "Africa",
  },
  {
    name: "Thailand",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Flag_of_Thailand.svg/1200px-Flag_of_Thailand.svg.png",
    route: "/immigration/thailand",
    region: "Asia",
  },
  {
    name: "South Korea",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Flag_of_South_Korea.svg/800px-Flag_of_South_Korea.svg.png",
    route: "/immigration/south-korea",
    region: "Asia",
  },
];

// Country Card Content
const CountryCardContent = ({ country }) => (
  <NavLink to={country.route} className="text-decoration-none">
    <div className="country-card">
      <img
        src={country.flag}
        alt={`${country.name} flag`}
        className="country-flag"
      />
      <h6 className="country-name">{country.name}</h6>
    </div>
  </NavLink>
);

// Main Component
const ImmCountry = () => {
  return (
    <div className="imm-country-container">
      <Container fluid className="px-4 py-4">
        <Row>
          <Col xs={12} className="mb-4">
            <h4 className="section-title">Immigration Policies by Country</h4>
          </Col>
        </Row>

        <Row>
          {/* Countries Grid */}
          <Col lg={9} md={8} xs={12}>
            <div className="immigration-grid">
              {COUNTRIES.map((country, index) => (
                <CountryCardContent key={index} country={country} />
              ))}
            </div>
          </Col>

          {/* Empty Right Side */}
          <Col lg={3} md={3}>
            <div className="d-flex justify-content-center">
              <small>Advertisement</small>
            </div>

            <Link to="https://forms.gle/YZ8rr4Dzpwi4R3An7">
              <Image
                className="mx-auto d-block pt-2"
                src="https://ayg.s3.us-east-2.amazonaws.com/bharat/Beige+and+Brown+Illustrative+Krishna+Janmashtami+Greeting+Instagram+Post+(1).gif"
                fluid
              />
            </Link>
          </Col>
        </Row>
      </Container>

      <style jsx>{`
        .imm-country-container {
          background: #f8f9fa;
          min-height: 90vh;
        }

        .section-title {
          font-size: 1.75rem;
          font-weight: 700;
          color: #2c3e50;
          border-bottom: 3px solid #3498db;
          padding-bottom: 12px;
        }

        .immigration-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 10px;
        }

        .empty-sidebar {
          min-height: 300px;
        }

        .country-card {
          background: white;
          border-radius: 10px;
          padding: 15px;
          text-align: center;
          transition: all 0.3s ease;
          cursor: pointer;
          border: 1px solid #e8e8e8;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }

        .country-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 16px rgba(52, 152, 219, 0.2);
          border-color: #3498db;
        }

        .country-flag {
          width: 60px;
          height: 45px;
          object-fit: cover;
          border-radius: 6px;
          margin-bottom: 8px;
          border: 1px solid #e0e0e0;
        }

        .country-name {
          font-size: 15px;
          font-weight: 600;
          color: #2c3e50;
          margin: 0;
        }

        @media (max-width: 1200px) {
          .immigration-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        @media (max-width: 768px) {
          .immigration-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 576px) {
          .immigration-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>
    </div>
  );
};

export default ImmCountry;
